import { render, staticRenderFns } from "./ProfileZoomData.vue?vue&type=template&id=4a9625ac&scoped=true&"
import script from "./ProfileZoomData.vue?vue&type=script&lang=js&"
export * from "./ProfileZoomData.vue?vue&type=script&lang=js&"
import style0 from "./ProfileZoomData.vue?vue&type=style&index=0&id=4a9625ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9625ac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VFlex,VIcon,VRow})
